/**
 * Created by Admin on 20.02.2018.
 */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Modal from '../../../uiKit/Modal'
import { PlusIcon } from '../../../uiKit/icons/Icons'
import NewBotModal from './NewBotModal'

const styles = () => ({
  item: {
    height: 48,
    padding: '0 20px',
    boxSizing: 'border-box',
    background: 'var(--careco-primary)',
    border: 'none',
    borderRadius: 'var(--careco-rounded-sm)',
    fontFamily: 'var(--careco-font)',
    fontSize: 14,
    fontWeight: 600,
    color: '#ffffff',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': { background: 'var(--careco-primary-hover)' },
    '&:focus-visible': {
      outline: '2px solid var(--careco-primary)',
      outlineOffset: 2,
    },
  },
  itemText: {
    margin: 0,
  },
  // QCS creation adds the three-across package picker, which needs more room
  // than the default modal so the tier cards never crowd or wrap.
  paperWide: {
    width: 700,
    maxWidth: 'calc(100vw - 48px)',
  },
})

class CreateNewBot extends React.Component {
  state = {
    open: false,
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes, isQcs } = this.props
    const label = isQcs ? 'New QCS organisation' : 'New CareBrain organisation'
    return (
      <>
        <button
          type="button"
          className={classes.item}
          onClick={this.handleOpen}
          data-autotest={'create-new-bot-button'}>
          <PlusIcon width="14" height="14" color="#ffffff" />
          <p className={classes.itemText}>{label}</p>
        </button>

        <Modal
          open={this.state.open}
          onClose={this.handleClose}
          classes={isQcs ? { paper: classes.paperWide } : undefined}
          title={isQcs ? 'Create QCS organisation' : 'Create new CareBrain organisation'}>
          <NewBotModal
            new={true}
            isQcs={isQcs}
            buttonName="Create"
            botName=""
            onClose={this.handleClose}
            onCreated={this.props.onCreated}
          />
        </Modal>
      </>
    )
  }
}

CreateNewBot.propTypes = {
  isQcs: PropTypes.bool,
  onCreated: PropTypes.func,
}

const mapStateToProps = state => ({
  bots: state.bots,
})

export default withRouter(withStyles(styles)(connect(mapStateToProps)(CreateNewBot)))
